(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hexagon-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Shopify's {% javascript %} tag compiles this into an external,
    // cached, CSP-safe asset file instead of an inline <script> — it
    // can't be silently blocked the way inline scripts sometimes are.
    // Liquid isn't available inside this tag, so per-instance settings
    // (autoplay speed, transition speed, on/off flags) are read from
    // data-* attributes on the root element at runtime instead.
    function initHexCarousel(root) {

      if (!root || root.getAttribute('data-hex-carousel-ready') === 'true') {
        return;
      }

      try {

        var cards = Array.prototype.slice.call(
          root.querySelectorAll('[data-card-index]')
        );

        var dots = Array.prototype.slice.call(
          root.querySelectorAll('[data-dot-index]')
        );

        if (!cards.length) return;

        var totalCards = cards.length;
        var currentIndex = 0;
        var autoplayInterval = null;
        var isTransitioning = false;

        // Defensive defaults: guarantees a real number/boolean even if
        // a data attribute is ever missing or malformed.
        var autoplaySpeed =
          (parseFloat(root.getAttribute('data-autoplay-speed')) || 4) * 1000;
        var transitionDuration =
          (parseFloat(root.getAttribute('data-transition-speed')) || 0.8) * 1000;
        var enableAutoplay =
          root.getAttribute('data-enable-autoplay') === 'true';
        var pauseOnHover =
          root.getAttribute('data-pause-on-hover') === 'true';

        function getCardPosition(index) {

          var diff = (index - currentIndex + totalCards) % totalCards;

          if (diff === 0) return 'active';
          if (diff === 1) return 'right';
          if (diff === totalCards - 1) return 'left';

          return 'hidden';

        }

        function updateCarousel() {

          cards.forEach(function (card, index) {

            card.classList.remove('left', 'active', 'right', 'hidden');
            card.classList.add(getCardPosition(index));

          });

          dots.forEach(function (dot, index) {

            dot.classList.toggle('active', index === currentIndex);

          });

        }

        function stopAutoplay() {

          if (autoplayInterval) {
            clearInterval(autoplayInterval);
            autoplayInterval = null;
          }

        }

        function startAutoplay() {

          stopAutoplay();
          autoplayInterval = setInterval(nextSlide, autoplaySpeed);

        }

        function resetAutoplay() {

          if (enableAutoplay) {
            stopAutoplay();
            startAutoplay();
          }

        }

        function goToSlide(index) {

          if (isTransitioning) return;

          isTransitioning = true;
          currentIndex = index;

          updateCarousel();

          setTimeout(function () {
            isTransitioning = false;
          }, transitionDuration);

          resetAutoplay();

        }

        function nextSlide() {

          goToSlide((currentIndex + 1) % totalCards);

        }

        dots.forEach(function (dot, index) {

          dot.addEventListener('click', function () {

            if (!isTransitioning) goToSlide(index);

          });

        });

        cards.forEach(function (card) {

          card.addEventListener('click', function () {

            var index = parseInt(card.getAttribute('data-card-index'), 10);

            if (index !== currentIndex && !isTransitioning) {
              goToSlide(index);
            }

          });

        });

        if (pauseOnHover) {

          root.addEventListener('mouseenter', stopAutoplay);

          root.addEventListener('mouseleave', function () {
            if (enableAutoplay) startAutoplay();
          });

        }

        updateCarousel();

        if (enableAutoplay) startAutoplay();

        root.setAttribute('data-hex-carousel-ready', 'true');

        root.addEventListener('shopify:section:unload', stopAutoplay);

      } catch (err) {

        if (window.console && console.error) {
          console.error('Hex carousel init error:', err);
        }

      }

    }

    function initAllHexCarousels() {

      var roots = document.querySelectorAll('[data-hex-carousel-root]');

      roots.forEach(function (root) {
        initHexCarousel(root);
      });

    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllHexCarousels);
    } else {
      initAllHexCarousels();
    }

    // Theme Editor: re-init when this section is added/re-rendered.
    document.addEventListener('shopify:section:load', function (event) {

      var root = event.target.querySelector('[data-hex-carousel-root]');

      if (root) initHexCarousel(root);

    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
